import script from "./Page__About.vue?vue&type=script&setup=true&lang=js"
export * from "./Page__About.vue?vue&type=script&setup=true&lang=js"

import "./Page__About.vue?vue&type=style&index=0&id=c82de10a&lang=scss"

const __exports__ = script;

export default __exports__